module.exports = __webpack_public_path__ + "static/img/no-data.2ccee2c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/no-data.svg
// module id = E+/F
// module chunks = 4